import { render, staticRenderFns } from "./TableColaboradores.vue?vue&type=template&id=1051affc&scoped=true&"
import script from "./TableColaboradores.vue?vue&type=script&lang=js&"
export * from "./TableColaboradores.vue?vue&type=script&lang=js&"
import style0 from "./TableColaboradores.vue?vue&type=style&index=0&id=1051affc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051affc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
